export default {
  admin: {
    user: {
      icon: 'dripicons-user',
      label: 'Users',
      link: '/users'
    },
    settings: {
      icon: 'dripicons-gear',
      label: 'Settings',
      link: '/settings'
    },
    logout: {
      icon: 'dripicons-exit',
      label: 'Logout',
      link: '/logout'
    }
  },
  doctor: {
    dashboard: {
      icon: 'dripicons-meter',
      label: 'Dashboard',
      link: '/dashboard'
    },
    fcfs: {
      icon: 'dripicons-clock',
      label: 'Queue',
      link: '/fcfs',
      badge: {
        variant: 'success',
        value: 0
      }
    },
    appointments: {
      icon: 'dripicons-calendar',
      label: 'Appointments',
      link: '/appointments'
    },
    patients: {
      icon: 'dripicons-user-group',
      label: 'Patients',
      link: '/patients'
    },
    certificate: {
      icon: 'dripicons-document',
      label: 'Certificate',
      link: '/certificate'
    },
    medicines: {
      icon: 'dripicons-pill',
      label: 'Medicines',
      link: '/medicines'
    },
    reminders: {
      icon: 'dripicons-to-do',
      label: 'Reminders',
      link: '/reminders'
    },
    settings: {
      icon: 'dripicons-gear',
      label: 'Settings',
      link: '/settings'
    },
    logout: {
      icon: 'dripicons-exit',
      label: 'Logout',
      link: '/logout'
    }
  },
  staff: {
    dashboard: {
      icon: 'dripicons-meter',
      label: 'Dashboard',
      link: '/dashboard'
    },
    fcfs: {
      icon: 'dripicons-clock',
      label: 'FCFS',
      link: '/fcfs',
      badge: {
        variant: 'success',
        value: 0
      }
    },
    appointments: {
      icon: 'dripicons-calendar',
      label: 'Appointments',
      link: '/appointments'
    },
    doctors: {
      icon: 'dripicons-user',
      label: 'Doctors',
      link: '/doctors'
    },
    patients: {
      icon: 'dripicons-user-group',
      label: 'Patients',
      link: '/patients'
    },
    medicines: {
      icon: 'dripicons-pill',
      label: 'Medicines',
      link: '/medicines'
    },
    reminders: {
      icon: 'dripicons-bell',
      label: 'Reminders',
      link: '/reminders'
    },
    logout: {
      icon: 'dripicons-exit',
      label: 'Logout',
      link: '/logout'
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/links.js